"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableContractsModule = void 0;
var lodash_1 = require("lodash");
var fitpos_api_1 = require("../../../api/fitpos-api");
var helper_1 = require("../../../helper");
var object_service_1 = require("../../../object-service");
var translation_1 = __importDefault(require("../../../translation"));
var variables_const_1 = require("../../../variables.const");
var checkout_1 = require("../../checkout/checkout");
var data_processing_service_1 = require("../services/data-processing.service");
var open_api_service_1 = require("../services/open-api.service");
var recaptcha_token_service_1 = require("../services/recaptcha-token.service");
var AvailableContractsModule = /** @class */ (function () {
    function AvailableContractsModule() {
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
        this.checkOutModule = object_service_1.ObjectService.getInstance(checkout_1.Checkout);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
        this.openApiService = object_service_1.ObjectService.getInstance(open_api_service_1.OpenApiService);
        this.recaptchaTokenService = object_service_1.ObjectService.getInstance(recaptcha_token_service_1.RecaptchaTokenService);
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.offerings = [];
        this.contracts = [];
    }
    AvailableContractsModule.prototype.dataHidePressed = function (section) {
        if (section === 'modules') {
            this.checkOutModule.resetSelectedModules();
        }
    };
    AvailableContractsModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var _ActionMapping, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.customer = customer;
                        this.section =
                            moduleDiv.getAttribute('data-module') === 'available-modules'
                                ? 'modules'
                                : 'checkout';
                        _ActionMapping = {
                            submit: function () { return _this.submitInputs(); },
                        };
                        _a = this;
                        return [4 /*yield*/, this.fitposAPI.getCustomerContractData(customer.id, 'ACTIVE')];
                    case 1:
                        _a.contracts = _b.sent();
                        $('[data-reset="true"]').on('click', function (event) {
                            event.preventDefault();
                            event.stopPropagation();
                            _this.dataHidePressed(_this.section);
                        });
                        this.dataProcessing.mapDataAction(moduleDiv, _ActionMapping);
                        this.checkOutModule.loadModule(__assign(__assign({}, variables_const_1._settings), { refObjectId: variables_const_1._settings.fitpos.refObjectAvailableContracts, section: this.section, modules: __assign(__assign({ noRedirect: true }, ((variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) || {})), { callback: function (modules) {
                                    console.error(modules);
                                    _this.selectedTerm = modules.selectedTerm;
                                    $('[data-show="onModuleSelected"]').css('display', '');
                                    var totalPrice = 0;
                                    $('[data-get]').each(function (a, b) {
                                        var path = b.getAttribute('data-get');
                                        if (path === 'totalPrice') {
                                            for (var _i = 0, _a = modules.allModules; _i < _a.length; _i++) {
                                                var module_1 = _a[_i];
                                                totalPrice += module_1.price;
                                            }
                                            b.innerHTML = totalPrice + '€';
                                        }
                                    });
                                } }), checkout: __assign(__assign({}, ((variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.checkout) || {})), { noRedirect: true, callback: function (obj) {
                                    _this.offerings = obj.offerings;
                                    _this.selectedTerm = obj.selectedTerm;
                                    _this.selectedOffering = obj.selectedOffering;
                                    $('[data-show="onTermSelected"]').css('display', '');
                                    _this.updateDataGets();
                                } }) })); // TODO if not defined
                        this.recaptchaTokenService.renderReCaptcha(function (token) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        console.log('token is ready', token);
                                        this.token = token;
                                        return [4 /*yield*/, this.submitInputs()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailableContractsModule.prototype.updateDataGets = function () {
        var _this = this;
        $('[data-get]').each(function (a, b) {
            var path = b.getAttribute('data-get');
            if ((0, lodash_1.get)(_this.selectedTerm, path)) {
                b.innerHTML = translation_1.default.t((0, lodash_1.get)(_this.selectedTerm, path));
            }
        });
    };
    AvailableContractsModule.prototype.submitInputs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var performSubmit, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        performSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
                            var freeModules, paidModules, _i, _a, key;
                            var _this = this;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        freeModules = [], paidModules = [];
                                        if (this.section === 'modules') {
                                            for (_i = 0, _a = ['selectableModules', 'optionalModules']; _i < _a.length; _i++) {
                                                key = _a[_i];
                                                if (localStorage.getItem(key)) {
                                                    freeModules = JSON.parse(localStorage.getItem(key)).map(function (a) { return ({
                                                        id: a,
                                                    }); });
                                                }
                                            }
                                        }
                                        console.log('customer & contract', this.customer, this.contracts);
                                        return [4 /*yield*/, this.openApiService.cancelContractExtraordinary(this.token, this.customer, this.contracts[0])];
                                    case 1:
                                        _b.sent();
                                        this.helper.createLoadingScreen();
                                        return [4 /*yield*/, this.openApiService.createNewContract(this.customer, variables_const_1._settings.studioId, {
                                                rateBundleTermId: this.selectedTerm.id,
                                                startDate: new Date().toISOString().replace(/T.*/, ''),
                                                selectedRateBundleModules: freeModules,
                                                optionalRateBundleTermModules: paidModules,
                                            })];
                                    case 2:
                                        _b.sent();
                                        if (variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.redirect) {
                                            setTimeout(function () {
                                                _this.helper.deleteLoadingScreen();
                                                window.location.href = variables_const_1._settings.redirect;
                                            }, 3000);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!!this.token) return [3 /*break*/, 1];
                        this.recaptchaTokenService.executeCaptcha();
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, performSubmit()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.helper.deleteLoadingScreen();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return AvailableContractsModule;
}());
exports.AvailableContractsModule = AvailableContractsModule;
